import { Component, OnInit, OnDestroy } from '@angular/core';

import { MeteorUser } from '../../../../../../backend/server/data-models/meteor-user/meteor-user';
import { Subscription } from 'rxjs';
import { SettingsService } from '../../../core/settings/settings.service';
import { MongoObservable } from 'meteor-rxjs';
import { UserService } from '../../../routes/user/user.service';

@Component({
    selector: 'app-userblock',
    templateUrl: './userblock.component.html',
    styleUrls: ['./userblock.component.scss']
})
export class UserblockComponent implements OnInit, OnDestroy {

    private userSubscription: Subscription;
    email: string = "";
    name: string = "";
    picture: string = "";
    userBlockVisible: boolean = false;

    constructor(
        public settings: SettingsService,
        public userService: UserService
    ) { }

    async ngOnInit() {
        this.userBlockVisible = this.settings.getLayoutSetting('hideSidebarUserBlock');
        this.userSubscription = new MongoObservable.Collection<any>(Meteor.users).find({ _id: Meteor.userId() })
            .subscribe((users: MeteorUser[]) => {
                if (users.length !== 1) return;
                const user = users[0];
                // console.warn("SIDEBAR - USERBLOCK - USER CHANGING"); console.warn(user);
                if (user.profile && user.profile.layout) {
                    this.name = user.profile.displayName || "?Anonymous?";
                    let email = user.emails.filter(em => em.verified && em.address)[0]
                    this.email = email ? email.address : "";
                    this.picture = user.profile.picture ? user.profile.picture : "../../../assets/img/user/14.jpg";
                    this.userBlockVisible = !user.profile.layout.hideSidebarUserBlock;
                }
            });
    }

    ngOnDestroy() {
        if (this.userSubscription) this.userSubscription.unsubscribe();
    }

}
